/**
 * Check-in New form page. Shown after user selects a document on the landing page
 * and clicks "Check-in New". Reads selectedDocument from location.state and syncs to tools.
 * Route: /check-in-new/form
 */
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Stack } from "@fluentui/react";
import { useTheme } from "../../theme/OAS365Theme";
import { useTools } from "../../redux/hooks/useTools";
import {
  CHECKIN_NEW_PAGE_NAME,
  CHECKIN_NEW,
  DATA_LOAD_STATUS,
  CHECKIN_FORM_LAYOUT_MIN_WIDTH_PX,
} from "../../redux/constants/metaData";
import { APP_ROUTES } from "../../routes/routeConfig";
import CheckInNew from "./components/CheckInNew";

function CheckInFormPage() {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const tools = useTools();
  const selectedDocument = location.state?.selectedDocument;
  const cameFromAllDocuments = location.state?.from === APP_ROUTES.allDocuments;

  useEffect(() => {
    if (!selectedDocument) {
     
      if (!cameFromAllDocuments) {
        navigate(APP_ROUTES.checkInNew, { replace: true });
      }
      return;
    }
    const title = selectedDocument.name?.substring(
      0,
      selectedDocument.name?.indexOf(".") ?? selectedDocument.name?.length
    ) ?? "";
    const fileName = selectedDocument.name ?? "";
    const fileType = selectedDocument.fileType ?? "";

    tools.onDocTitleChange(title);
    const allFiles = [
      {
        name: fileName,
        type: fileType,
        size: "0 KB",
        base64: "",
        base64str: "",
      },
    ];
    tools.onFileUploadChange(allFiles, allFiles.length);
    tools.onCheckinPageNameChanged(CHECKIN_NEW_PAGE_NAME.basic);
    tools.onDocCheckinTypeChange(CHECKIN_NEW);
    tools.onBasicDataProgressChange(DATA_LOAD_STATUS.onLoad);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once when selectedDocument is set
  }, [selectedDocument]);

  return (
    <Stack
      enableScopedSelectors
      styles={{ root: { background: theme.colors.backgroundColor, overflow: "hidden", height: "100%" } }}
      tokens={{ childrenGap: 0, padding: 0 }}
    >
      <Stack.Item
        grow
        styles={{
          root: {
            flex: "1 1 auto",
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            overflowX: "auto",
            overflowY: "hidden",
            WebkitOverflowScrolling: "touch",
          },
        }}
      >
        <div
          style={{
            minWidth: CHECKIN_FORM_LAYOUT_MIN_WIDTH_PX,
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            flex: "1 1 auto",
            minHeight: 0,
          }}
        >
          <Stack grow>
            <Stack.Item
              grow
              styles={{
                root: {
                  height: "calc(100vh - 100px)",
                  background: theme.colors.backgroundColor,
                  padding: "5px",
                  margin: "0 10px",
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                  minHeight: 0,
                },
              }}
            >
              <div style={{ marginRight: "10px", flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
                <CheckInNew />
              </div>
            </Stack.Item>
          </Stack>
        </div>
      </Stack.Item>
    </Stack>
  );
}

export default CheckInFormPage;
